import { useEffect, useState } from "react"

import { useNetworkStore, useOnlineStore } from "@/shared/store"
import { useI18n } from "@/shared/i18n"

import { cn } from "@/shared/lib/utils"

export const TopBar = () => {
  const { t } = useI18n()

  const [offlineBannerDismissed, setOfflineBannerDismissed] = useState(false)
  const [touchStartY, setTouchStartY] = useState<number | null>(null)

  const currentOnline = useOnlineStore((s) => s.currentOnline)
  const isOnline = useNetworkStore((s) => s.isOnline)

  const statusLabel = isOnline
    ? t("topBar.onlineLabel", { count: currentOnline ?? "..." })
    : t("topBar.offlineLabel")

  useEffect(() => {
    if (!isOnline) {
      setOfflineBannerDismissed(false)
    }
  }, [isOnline])

  const handleBannerTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    setTouchStartY(event.touches[0]?.clientY ?? null)
  }

  const handleBannerTouchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    if (touchStartY == null) return

    const touchEndY = event.changedTouches[0]?.clientY ?? touchStartY
    const swipeDistance = touchStartY - touchEndY
    const SWIPE_UP_THRESHOLD_PX = 30

    if (swipeDistance > SWIPE_UP_THRESHOLD_PX) {
      setOfflineBannerDismissed(true)
    }

    setTouchStartY(null)
  }

  return (
    <header className="sticky top-0 z-50">
      <div className="mx-auto flex max-w-2xl items-center justify-center px-3 py-0.5">
        <div
          className="flex h-[30px] items-center justify-center gap-1 whitespace-nowrap rounded-[32px] px-2 py-1"
          style={{
            background: "rgba(65, 63, 64, 0.4)",
            backdropFilter: "blur(5px)",
          }}
        >
          <span
            className={cn(
              "h-1.5 w-1.5 shrink-0 rounded-full",
              isOnline ? "bg-green-100" : "bg-warning-100"
            )}
          />
          <span className="text-sm/[22px] font-medium text-white">
            {statusLabel}
          </span>
        </div>
      </div>

      {!isOnline && !offlineBannerDismissed && (
        <div className="mx-auto mt-1 max-w-2xl px-3">
          <div
            className="rounded-xl border border-warning-100 bg-warning-10 px-3 py-1.5 text-center text-xs text-warning-100"
            onTouchStart={handleBannerTouchStart}
            onTouchEnd={handleBannerTouchEnd}
          >
            {t("topBar.offlineBanner")}
          </div>
        </div>
      )}
    </header>
  )
}
